import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';

import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Stack, Typography } from '@mui/material';
import { FilterSVG } from '../../../../../components';
import { palette } from '../../../../../styles/theme';

export default function SummariesFiltersModal ({
    show,
    onHide,
    date,
    setDate,
    handleSearch,
    handleCleanFilters,
}) {
    const [dateFrom, dateTo] = date;
    const { t } = useTranslation();

    const handleDateFromChange = (newStartDate) => {
        setDate([newStartDate, date[1]]);
    };

    const handleDateToChange = (newEndDate) => {
        setDate([date[0], newEndDate]);
    };

    const handleCancelChanges = () => {
        onHide();
    };

    return (
        <Dialog
            open={show}
            onClose={() => handleCancelChanges()}
            PaperProps={{ style: { width: '320px', minWidth: '320px', minHeight: '345px', height: '400px', borderRadius: '12px' } }}
        >
            <DialogTitle>
                <Box display='flex'>
                    <FilterSVG customStroke={palette.secondary[600]}/>
                    <Typography sx={{ marginLeft: '6px', marginTop: '3px' }} variant='pageTitle'>
                        {t('filter.modal.title')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box>
                    <Typography variant='filterTitle' >{t('filter.modal.date.title')}</Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <Stack direction={'row'} style={{ marginTop: '10px' }} gap={'16px'}>
                            <Box display='flex' alignItems='center' style={{ width: '190px' }} >
                                <MobileDatePicker
                                    inputProps={{ size: 'small' }}
                                    disableToolbar
                                    margin='normal'
                                    id='date-picker-dialog-from'
                                    label={t('filter.modal.date.from')}
                                    format='dd/MM/yyyy'
                                    value={dateFrom || null}
                                    onChange={handleDateFromChange}
                                    slotProps={{
                                        textField: { color: 'secondary' }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: '35px',
                                            backgroundColor: 'white',

                                        },
                                        '& .MuiInputLabel-root': {
                                            lineHeight: '10px'
                                        },
                                    }}
                                />
                            </Box>
                            <Box style={{ width: '190px' }}>
                                <MobileDatePicker
                                    disableToolbar
                                    margin='normal'
                                    id='date-picker-dialog-to'
                                    label={t('filter.modal.date.to')}
                                    format='dd/MM/yyyy'
                                    value={dateTo || null}
                                    onChange={handleDateToChange}
                                    slotProps={{
                                        textField: { color: 'secondary' }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: '35px',
                                            backgroundColor: 'white',
                                        },
                                        '& .MuiInputLabel-root': {
                                            lineHeight: '10px'
                                        },
                                    }}
                                />
                            </Box>
                        </Stack>
                    </LocalizationProvider>
                </Box>
                <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flex: 1 }}>
                    <Button
                        style={{
                            textTransform: 'none',
                            width: '110px',
                            height: '28px',
                            fontSize: '14px',
                            marginRight: '8px',
                            marginBottom: '10px',
                            color: dateFrom && dateTo ? palette.secondary[600] : palette.disabled.main,
                        }}
                        onClick={handleCleanFilters}
                    >
                        {t('filter.modal.delete')}
                    </Button>
                    <Button
                        onClick={handleSearch}
                        disabled={!((dateFrom && dateTo))}
                        style={{
                            textTransform: 'none',
                            width: '94px',
                            height: '28px',
                            fontSize: '14px',
                            marginRight: '2px',
                            marginBottom: '10px',
                            borderRadius: '50px',
                            backgroundColor: (dateFrom && dateTo) ? palette.primary.main : palette.disabled[500],
                            color: 'white',
                        }}
                    >
                        {t('filter.modal.apply')}
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions>
                <Box />
            </DialogActions>
        </Dialog>
    );
}
